<template>
  <div class="c--contact-us"  v-if="isDisplayContactUs">

    <div class="fab">
      
      <div class="fab-list" v-if="isOpen">
        <div class="fab-button" @click="goToPage('charging-methods')">
          <ion-icon name="wallet-outline"></ion-icon>
        </div>
        <div class="fab-button">
          <a :href="`https://api.whatsapp.com/send?phone=${ support_phone }`" target="_blank"> 
            <ion-icon style="font-size: 16px;color: #fff;" name="logo-whatsapp"></ion-icon>
          </a>
          <!-- <ion-icon name="logo-whatsapp"></ion-icon> -->
        </div>
      </div>
      <div class="fab-button"  @click="toggleOpen">
        <ion-icon name="rocket-outline"></ion-icon>
      </div>
    </div>

  </div>
</template>

<script>
import { isDisplayContactUs } from '@/components/sidebar/state';
import router from "@/router";

export default {
  name: 'ContactUs',
  props: {
    msg: String
  },
  data() {
    
    return {
      isOpen: true,
      support_phone: '+352681140213',
    }
  },
  setup() {
    return { 
      isDisplayContactUs
    }
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    async goToPage(page){
      // console.log(page);
      router.push({ path: `/${page}` })
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.c--contact-us {
  position: relative;
}
.fab {
  position: fixed;
  bottom: 10px;
  right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.fab-button {
  width: 45px;
  height: 45px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  background: var(--public);
  color: #fff;
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
}
.fab-button a {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  font-size: 17px;
  color: #fff;
}
.fab-list {
  margin-bottom: 2px;
}
.fab-list .fab-button {
  width: 40px;
  height: 40px;
  font-size: 16px;
  margin-bottom: 5px;

}
















.content-footer {
  position: relative;
  min-height: 65px;
  padding: 16px;
  background: var(--box-background);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.f-first {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.f-first .logo {
  width: 32px;
}
.f-first .info-app-footer{
  padding: 0px 12px;
  text-align: start;
}
.f-first .info-app-footer p {
  font-size: 12px;
  color: var(--color-text);
  margin: 0;
}
.f-first .info-app-footer h3 {
  font-size: 12px;
  color: var(--color-text);
  margin: 0;
}
.f-second {
  text-align: start;
}
.f-second .item {
  font-size: 12px;
  color: var(--color-text);
}
.f-second .item .btn-item {
  padding-inline-start: 5px;
  text-decoration: none;
  color: var(--public);
}
.f-third {
  text-align: start;
}
.f-third .item {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  font-size: 12px;
  direction: ltr;
}
.f-third .item .ic {
  color: var(--color-text);
}
.f-third .item span {
  padding: 0px 5px;
  color: var(--color-text);
}




@media (max-width: 992px) {
  .content-footer {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
  .f-first,
  .f-second,
  .f-third {
    width: 100%;
    justify-content: center;
    margin-bottom: 15px;
  }
  .f-third {
    margin-bottom: unset;
    text-align: center;
  }
  .f-third .item {
    justify-content: center;
  }
}
</style>
